import React from "react";
import "../styles/autocomplete.css";
import Select from "react-select";
const Autocomplete = (props) => {
  //

  const onChange = (e) => {
    let newform = JSON.parse(JSON.stringify(props.formularioBuscado));

    newform[props.nameElement] = e.value;

    props.setformulario(newform);

    if (props.formularioUpdate) {
      let newformUpdate = JSON.parse(JSON.stringify(props.formularioUpdate));
      newformUpdate[props.nameElement] = e.value;

      props.setformularioUpdate(newformUpdate);
    }
  };

  return (
    <>
      <Select
        onChange={onChange}
        options={props.suggestions}
        maxMenuHeight={170}
        // Renderiza el menu desplegable en document.body (fuera del modal/form)
        // para que no expanda el contenedor padre cuando se abre.
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        value={props.suggestions.filter(
          (option) => option.value === props.value
        )}
      />
    </>
  );
};
export default Autocomplete;
